import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, doc, onSnapshot, orderBy, query, where, writeBatch } from "firebase/firestore";
import { auth, db } from "../firebase";
import Icon from "../components/Icon";
export default function ActivityPage({
  type = "notifications"
}) {
  const [items, setItems] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const uid = auth.currentUser?.uid;
  const reviews = type === "reviews";
  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    setError("");
    const source = reviews ? query(collection(db, "reviews"), where("reviewerId", "==", uid)) : query(collection(db, "users", uid, "notifications"), orderBy("createdAt", "desc"));
    return onSnapshot(source, snap => {
      setItems(snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      })));
      setLoading(false);
    }, () => {
      setError("โหลดข้อมูลไม่สำเร็จ กรุณาลองอีกครั้ง");
      setLoading(false);
    });
  }, [uid, reviews]);
  useEffect(() => {
    if (!reviews || !uid) return;
    return onSnapshot(query(collection(db, "rooms"), where("members", "array-contains", uid), where("status", "==", "released")), snap => setRooms(snap.docs.map(d => ({
      id: d.id,
      ...d.data()
    }))), () => setError("โหลดดีลที่รอรีวิวไม่สำเร็จ"));
  }, [uid, reviews]);
  async function markRead(id) {
    try {
      const batch = writeBatch(db);
      items.filter(n => !n.read && (!id || n.id === id)).forEach(n => batch.update(doc(db, "users", uid, "notifications", n.id), {
        read: true
      }));
      await batch.commit();
    } catch (_) {
      setError("อัปเดตสถานะไม่สำเร็จ กรุณาลองอีกครั้ง");
    }
  }
  const pending = rooms.filter(room => !items.some(review => review.roomId === room.id));
  return <section className="kl-info-page"><h1>{reviews ? "รีวิวของฉัน" : "การแจ้งเตือน"}</h1><p>{reviews ? "ให้คะแนนคู่ค้าจากดีลที่เสร็จสิ้นแล้ว" : "ติดตามความเคลื่อนไหวของดีลและบัญชีของคุณ"}</p>{error && <div className="error-msg" role="alert">{error}</div>}
    {reviews && <div className="kl-dashboard-stats"><div className="kl-stat"><span>รีวิวที่ให้แล้ว</span><strong>{items.length} รีวิว</strong></div><div className="kl-stat"><span>รอให้คะแนน</span><strong>{pending.length} ดีล</strong></div></div>}
    {reviews && pending.length > 0 && <article className="kl-info-card" style={{
      marginBottom: 22
    }}><h2>ดีลที่รอให้คะแนน</h2>{pending.map(room => <div className="kl-activity-row" key={room.id}><div><strong>{room.itemName}</strong><p>ดีล #{room.roomCode}</p></div><Link className="kl-support-link" to={`/chat/${room.id}`}>ให้คะแนนคู่ค้า →</Link></div>)}</article>}
    <article className="kl-info-card"><div className="kl-activity-heading"><h2>{reviews ? "ประวัติการให้คะแนน" : "ทั้งหมด"}</h2>{!reviews && items.some(n => !n.read) && <button onClick={() => markRead()} className="kl-support-link">อ่านทั้งหมด</button>}</div>
      {loading ? <p role="status">กำลังโหลด...</p> : items.length === 0 ? <p>{reviews ? "คุณยังไม่ได้ให้คะแนนคู่ค้า เมื่อดีลสำเร็จสามารถให้คะแนนได้จากห้องซื้อขาย" : "ยังไม่มีการแจ้งเตือนใหม่"}</p> : items.map(item => <div className={`kl-activity-row${!reviews && !item.read ? " unread" : ""}`} key={item.id}><Icon name={reviews ? "star" : "bell"} size={20} /><div><strong>{reviews ? `${item.stars}/5 • ${item.itemName || item.revieweeName}` : item.title}</strong><p>{reviews ? item.comment : item.message}</p><small>{item.createdAt?.toDate?.().toLocaleDateString("th-TH")}</small></div>{item.roomId && <Link className="kl-activity-link" to={`/chat/${item.roomId}`}>ดูดีล →</Link>}{!reviews && !item.read && <button className="kl-activity-link" onClick={() => markRead(item.id)}>อ่านแล้ว</button>}</div>)}
    </article>
  </section>;
}
